<template>
  <div class="loading">
    <span class="loading__spinner"></span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.loading {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 60px;

  &__spinner {
    display: inline-block;
    width: 38px;
    height: 38px;

    &:after {
      content: " ";
      display: block;
      width: 24px;
      height: 24px;
      margin-left: 8px;
      border-radius: 50%;
      border: 2px solid var(--button-color);
      border-color: var(--button-color) transparent var(--button-color)
        transparent;
      animation: loading 1.2s linear infinite;
    }
  }
}
@keyframes loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>